<template>
  <div class="invoice-info-manage">
    <el-card class="info-card">
      <el-tabs v-model="activeName">
        <el-tab-pane label="发票信息" name="info"></el-tab-pane>
        <el-tab-pane label="寄送地址" name="address"></el-tab-pane>
        <el-tab-pane label="电子邮箱" name="email"></el-tab-pane>
      </el-tabs>
      <!-- 发票信息 -->
      <div class="info-box" v-if="activeName=='info'">
        <template v-if="!isAddInvoiceInfo">
          <el-row>
            <span>发票信息有效 </span>
            <el-button size="small" type="text" @click="dialogVisibleProps=true">修改发票信息</el-button>
          </el-row>
          <p>
            <span class="info-label">发票抬头：</span>
            <span class="info-value">{{invoiceForm.title}}</span>
          </p>
          <p>
            <span class="info-label">抬头类型：</span>
            <span class="info-value">{{invoiceForm.titleTypeSelf}}</span>
          </p>
          <p>
            <span class="info-label">默认发票类型：</span>
            <span class="info-value">{{invoiceForm.defaultInvoiceTypeSelf}}</span>
          </p>
          <p>
            <span class="info-label">统一社会信用代码：</span>
            <span class="info-value">{{invoiceForm.creditCode}}</span>
          </p>
          <p v-if="user.role==2">
            <span class="info-label">开户银行名称：</span>
            <span class="info-value">{{invoiceForm.bankName}}</span>
          </p>
          <p v-if="user.role===2">
            <span class="info-label">基本开户账号：</span>
            <span class="info-value">{{invoiceForm.bankAccount}}</span>
          </p>
          <p v-if="user.role===2">
            <span class="info-label">注册场所地址：</span>
            <span class="info-value">{{invoiceForm.registPlaceAddress}}</span>
          </p>
          <p v-if="user.role===2">
            <span class="info-label">注册固定电话：</span>
            <span class="info-value">{{invoiceForm.registFixedPhone}}</span>
          </p>
        </template>
        <template v-else>
          <el-button size="small" type="primary" @click="dialogVisibleProps=true" icon="el-icon-plus">新增发票信息</el-button>
        </template>

      </div>
      <!-- 寄送地址 -->
      <div v-if="activeName=='address'">
        <el-row style="margin-bottom: 15px;">
          <el-button :disabled="addressData.length===20" size="small" type="primary" @click="addAddressFn" icon="el-icon-plus">新增地址</el-button>
        </el-row>
        <el-table :data="addressData" >
          <template v-for="(item,index) in tableColumns">
            <el-table-column :prop="item.key" :label="item.label" :min-width="item.width" :key="index"></el-table-column>
          </template>
          <el-table-column label="操作" :min-width="150" fixed="right">
            <template slot-scope="scope">
              <div style="text-align: right;">
                <p v-if="scope.row.defaultFlag===1" class="default-text">默认地址</p>
                <el-button type="text" size="small" @click="addressUpdata(scope.row)">修改</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" @click="basicsAdd(scope.row)">以此新增</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" @click="addressDel(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <p v-if="addressData.length>0" style="color: #999; font-size: 12px;">共{{addressData.length}}个地址，最多保存20个 </p>
      </div>
      <!-- 电子邮箱 -->
      <div v-if="activeName=='email'">
        <el-row style="margin-bottom: 15px;">
          <el-button :disabled="emailData.length===20" size="small" type="primary" @click="addEmailFn" icon="el-icon-plus">新增邮箱</el-button>
        </el-row>
        <el-table :data="emailData" >
          <el-table-column prop="email" label="邮箱" ></el-table-column>
          <el-table-column label="操作" :width="180" fixed="right">
            <template slot-scope="scope">
              <div style="text-align: right;">
                <p v-if="scope.row.defaultFlag===1" class="default-text">默认邮箱</p>
                <el-button type="text" size="small" @click="emailUpdata(scope.row)">修改</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" @click="emailDel(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <p v-if="emailData.length>0" style="color: #999; font-size: 12px;">共{{emailData.length}}个邮箱，最多保存20个 </p>
      </div>
    </el-card>
    <InvoiceInfoDialog
      :isAdd="isAddInvoiceInfo"
      :invoiceFormProps="invoiceForm"
      :dialogVisibleProps="dialogVisibleProps"
      @cancleInvoiceDialog="cancleInvoiceDialog" />
    <AddressDialog
      :isAdd="isAddAddress"
      :addressRowInfoProps="addressRowInfoProps"
      :addressDialogVisibleProps="addressDialogVisibleProps"
      @cancleAddressDialog="cancleAddressDialog"/>
    <EmailDialog
      :isAdd="isAddEmail"
      :emailRowInfoProps="emailRowInfoProps"
      :emailDialogVisibleProps="emailDialogVisibleProps"
      @cancleEmailDialog="cancleEmailDialog"/>
  </div>
</template>
<script>
import InvoiceInfoDialog from './components/invoiceInfoDialog.vue'
import AddressDialog from './components/addressDialog.vue'
import EmailDialog from './components/emailDialog.vue'
const columns = [
  {key: 'name', label: '收件人姓名', width: '160'},
  {key: 'mobile', label: '电话号码', width: '120'},
  {key: 'address', label: '地址', width: '200'},
  {key: 'zipCode', label: '邮编', width: '100'},
]
export default {
  components: {
    InvoiceInfoDialog, // 发票信息
    AddressDialog, // 寄送地址
    EmailDialog, // 邮箱
  },
  data() {
    return {
      activeName: 'info',
      addressData: [],
      tableColumns: columns,
      emailData: [],
      dialogVisibleProps: false, // 修改发票信息弹窗
      titleTypeObj:['个人','企业','事业单位'],
      defaultInvoiceTypeObj: ['增值税普通发票', '增值税专用发票'],
      invoiceForm: {
        titleType: '',
        titleTypeSelf: '', //抬头类型
        title: '', //发票抬头
        defaultInvoiceType: '',
        defaultInvoiceTypeSelf: '', //默认发票类型
        creditCode: '', // 统一社会信用代码
        bankName: '', //开户银行名称
        bankAccount: '', // 基本开户账号
        registPlaceAddress: '', // 注册场所地址
        registFixedPhone: '', // 注册固定电话
        taxpayerQualification: '', // 一般纳税人资质
        businessLicense: '', // 营业执照复印件
        accountOpeningPermit: '', //开户许可证
        specialTicketInfo: '', // 开专票信息
      },
      isAddInvoiceInfo: false, //默认都是编辑发票信息
      isAddAddress: false, //默认编辑寄送地址
      addressDialogVisibleProps: false, //寄送地址弹窗是否显示
      addressRowInfoProps: { // 编辑当前行的地址
        name: '',
        address: '',
        mobile: '',
        zipCode: '',
        defaultFlag: 0, // 0否 1是
        provinceIndex: {},
        cityIndex: '',
      },
      isAddEmail: false, //默认编辑邮箱
      emailDialogVisibleProps: false, //邮箱弹窗是否显示
      emailRowInfoProps: { // 编辑当前行的邮箱
        email: '',
        defaultFlag: 0 // 0否 1是
      },
    }
  },
  watch: {},
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    // 新增发票信息模式时，新增发票信息tab直接展示新增发票信息按钮
    if(this.$route.query.type=="add") this.isAddInvoiceInfo = true;
    this.getIvoiceData();
    this.getAddressData();
    this.getEmailData();
  },
  methods: {
    // 修改发票信息取消
    cancleInvoiceDialog(val) {
      if(val) { // 'addAfter',新增成功之后，隐藏新增按钮，只显示编辑
        this.isAddInvoiceInfo = false;
        this.$router.push('/invoice/info')
      }
      this.getIvoiceData();
      this.dialogVisibleProps = false;
    },
    //寄送地址弹窗关闭
    cancleAddressDialog() {
      this.addressDialogVisibleProps = false;
      // 将弹窗表单的信息清空，单纯使用resetFields不好用，表单数据是从当前组件传递进弹窗中的
      for(let index in this.addressRowInfoProps){
        this.addressRowInfoProps[index] = '';
      }
      this.addressRowInfoProps.provinceIndex = {};
      this.getAddressData();
    },
    // 邮箱弹窗关闭
    cancleEmailDialog() {
      this.emailDialogVisibleProps = false;
      // 将弹窗表单的信息清空，单纯使用resetFields不好用，表单数据是从当前组件传递进弹窗中的
      this.emailRowInfoProps.email = '';
      this.emailRowInfoProps.defaultFlag = 0
      this.getEmailData();
    },
    // 新增邮箱
    addEmailFn() {
      this.emailDialogVisibleProps=true;
      this.isAddEmail = true;
    },
    // 邮箱修改
    emailUpdata(row) {
      this.emailDialogVisibleProps=true;
      this.isAddEmail = false;
      this.emailRowInfoProps = row;
    },
    // 邮箱删除
    emailDel(id) {
      let params = {
        userId: this.user.userId,
        id: id
      }
      this.postRequestJson('/uac/email/delete', params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            this.$message.success('删除成功！');
            this.getEmailData();
          }
        }
      })
    },
    // 新增寄送地址
    addAddressFn() {
      this.addressDialogVisibleProps=true;
      this.isAddAddress = true;
    },
    // 寄送地址修改
    addressUpdata(row) {
      this.addressDialogVisibleProps=true;
      this.isAddAddress = false;
      let addressArr = row.address.split(' / ')
      this.addressRowInfoProps = Object.assign(this.addressRowInfoProps,row,{
        address: addressArr[2],
        provinceIndex: addressArr[0],
        cityIndex: addressArr[1],
      })
    },
    // 以此新增寄送地址
    basicsAdd(row) {
      this.addressDialogVisibleProps=true;
      this.isAddAddress = true;
      let addressArr = row.address.split(' / ')
      this.addressRowInfoProps = Object.assign(this.addressRowInfoProps,row,{
        address: addressArr[2],
        provinceIndex: addressArr[0],
        cityIndex: addressArr[1],
      })
    },
    // 删除寄送地址
    addressDel(id) {
      let params = {
        userId: this.user.userId,
        id: id
      }
      this.postRequestJson('/uac/address/delete', params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            this.$message.success('删除成功！');
            this.getAddressData();
          }
        }
      })
    },
    // 获取发票信息
    getIvoiceData() {
      let params = {
        userId: this.user.userId
      }
      this.getRequest('/ofc/getPersonalInvoiceInfo',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            if(res.data.result) {
              this.invoiceForm = Object.assign(JSON.parse(JSON.stringify(this.invoiceForm)), res.data.result,{
                titleTypeSelf: res.data.result.titleType!=null||res.data.result.titleType!=undefined? this.titleTypeObj[res.data.result.titleType]:'',
                defaultInvoiceTypeSelf: res.data.result.defaultInvoiceType!=null||res.data.result.defaultInvoiceType!=undefined? this.defaultInvoiceTypeObj[res.data.result.defaultInvoiceType]:'',
              })
            }
          }
        }
      })
    },
    // 获取寄送地址数据
    getAddressData() {
      let params = {
        userId: this.user.userId
      }
      this.getRequest('/uac/address/search',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            this.addressData = res.data.result.records;
          }
        }
      })
    },
    // 获取邮箱列表
    getEmailData() {
      let params = {
        userId: this.user.userId
      }
      this.getRequest('/uac/email/search',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            this.emailData = res.data.result.records;
          }
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
 .invoice-info-manage{
   height: 100%;
   .info-card{
     margin-top: 15px;
     height: 95%;
     .info-box{
      >p{
        .info-label {
          display: inline-block;
          width: 130px;
          text-align: right;
        }
      }
     }
   }
   .default-text {
     color: #E6A23C;
     border: 1px solid #E6A23C;
     border-radius: 2px;
     font-size: 10px;
     display: inline-block;
     margin: 0 5px 0 0;
     line-height: 18px;
    padding: 0 3px;
   }
 }
 </style>
